import { InlineText1 } from '@cian/ui-kit/typography/InlineText';

import { FC } from 'react';

export const SpecialistDescription: FC = () => {
  return (
    <InlineText1 as="span" color="black_100" fontWeight="normal">
      Наш специалист свяжется с вами в течение 2 рабочих дней
    </InlineText1>
  );
};

SpecialistDescription.displayName = 'SpecialistDescription';
